import axios, { AxiosPromise, CancelToken } from 'axios';
import { Contact } from '../sic-lib/types/Contact';
import { ContactList, ContactsListRequest } from '../sic-lib/types/ContactList';
import { apiInstance as instance } from './';

let requestContactsList_cancel: any;
/**
 * requestContactsList
 *
 * @description
 * Makes a HTTP request for contacts matching the request parameters
 */
export function requestContactsList(data: ContactsListRequest): AxiosPromise<ContactList> {
    if (requestContactsList_cancel) requestContactsList_cancel();

    return instance.post('/contacts', data, {
        cancelToken: new axios.CancelToken(function executor(c) {
            requestContactsList_cancel = c;
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

let requestContactById_cancel: any;
/**
 * requestContactById
 *
 * @description
 * Makes a HTTP request for a specifici contact based on contact's Id
 */
export function requestContactById(
    contactId: number,
    //cancelToken: CancelToken
): AxiosPromise<Contact> {
    if (requestContactById_cancel) requestContactById_cancel();

    //~ TIP: URL used matches contact fields endpoint but makes sense grouped with contact requests
    return instance.get(`/contacts/${contactId}/fields`, {
        cancelToken: new axios.CancelToken(function executor(c) {
            requestContactById_cancel = c;
        }),
    });
}

/**
 * requestDeleteContact
 *
 * @description
 * Makes a HTTP request to delete the contact matching the specified contactId
 *
 * @returns
 * Some trivial value whcih is meant to confirm operation was completed successfuly
 */
export function requestDeleteContact(
    contactId: number,
    cancelToken: CancelToken,
): AxiosPromise<unknown> {
    return instance.delete(`/contacts/${contactId}`, {
        cancelToken: cancelToken,
    });
}
